
export default {
  name: 'Promotions',

  data: function () {
    return {
      popUpMessage: '',
    };
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    promotions: function () {
      return (this.product?.promotions || []).map((t) => ({
        ...t,
        url: t?.dynamicFields?.custom_url || t.url,
      }));
    },
  },

  methods: {
    clickTag: function (promotion) {
      if (!promotion.description) {
        return;
      }
      if (!process.client) {
        return;
      }
      if (window.innerWidth > 1199) {
        return;
      }

      this.popUpMessage = promotion.description;
    },
    closePopUp: function () {
      this.popUpMessage = '';
    },
  },
};
